
















































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppFormCheckbox from '@/components/AppFormCheckbox.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import { IInsuredDriverInput } from '@/modules/Insured/interfaces/insured-form'
import { licenseValues, duiValues, srValues, relationValues } from '@/modules/Insured/helpers/insured'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppFormCheckbox,
    AppDatePicker
  }
})
export default class InsuredFormDriver extends Vue {
  @Prop({ type: Object as () => IInsuredDriverInput }) value!: IInsuredDriverInput

  licenseValues = licenseValues
  duiValues = duiValues
  srValues = srValues
  relationValues = relationValues

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
